<script setup lang="ts">
import PatientGroupBadge from './PatientGroupBadge.vue';

defineProps<{
  visible: boolean;
  title: string;
  description?: string;
  photo?: string;
  patientGroup?: 'children' | 'adults';
}>();

const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'select'): void;
}>();
</script>

<template>
  <Teleport to="body">
    <Transition name="mbw-sheet">
      <div v-if="visible" class="mbw-modal-overlay" @click.self="emit('close')">
        <div class="mbw-modal" :class="{ 'mbw-modal--centered': !!photo }">
          <div v-if="photo" class="mbw-modal-photo-wrap">
            <img class="mbw-modal-photo" :src="photo" :alt="title" />
            <PatientGroupBadge :group="patientGroup" />
          </div>
          <div class="mbw-modal-title">{{ title }}</div>
          <div v-if="description" class="mbw-modal-content" v-html="description" />
          <div class="mbw-modal-actions">
            <button type="button" class="mbw-modal-btn mbw-modal-btn--outline" @click="emit('close')">Zamknij</button>
            <button type="button" class="mbw-modal-btn mbw-modal-btn--primary" @click="emit('select')">Wybierz</button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>
